const LONG_OFFSET = /^GMT(?:([+\-−])(\d{1,2})(?::(\d{2}))?)?$/

/**
 * Offset from UTC of a time zone at an instant, in minutes (Paris in summer: 120), by the time zone
 * rules of the runtime: a browser and the API may disagree when one of them has outdated rules.
 * Null for an unknown time zone.
 */
export const getTimeZoneOffsetMinutes = (timeZone: string, at: Date = new Date()): number | null => {
  try {
    const name = new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'longOffset' })
      .formatToParts(at)
      .find(part => part.type === 'timeZoneName')?.value || ''
    const match = LONG_OFFSET.exec(name)
    if (!match)
      return null
    if (!match[1])
      return 0

    const minutes = Number(match[2]) * 60 + Number(match[3] || 0)
    return match[1] === '+' ? minutes : -minutes
  }
  catch {
    return null
  }
}
